import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { connect } from '../../../common/react-redux';
import { createBank } from '../../api/banks';
import CreateBankModal from './presenter';
import * as modalActions from '../../../common/actions/modal';
import { CREATE_BANK_MODAL, TEMPORARY_BANK_ID } from '@instructure/quiz-common';
import { changeBank, clearModifications } from '../../../common/actions/modifications';
import Bank from '../../../common/records/Bank';
import { showError, hideError } from '../../../common/actions/errorsShowing';
import { getModalTrigger } from '../../../common/util/modalHelpers';
import { screenreaderNotification } from '../../../common/actions/alerts';
import { featureOn } from '../../../common/util/featureCheck';
function mapStateToProps(state) {
  var temporaryBank = new Bank(state.getIn(['modifications', 'banks', TEMPORARY_BANK_ID]));
  var errorsMap = state.get('errorsShowing', Map());
  var errorKey = "".concat(TEMPORARY_BANK_ID, "_create_bank");
  return {
    modalOpen: state.getIn(['modal', 'isOpen']) === CREATE_BANK_MODAL,
    modalTrigger: getModalTrigger(state),
    onCreateBank: state.getIn(['modal', 'options', 'onCreateBank']),
    temporaryBank: temporaryBank,
    errorKey: errorKey,
    displayError: errorsMap.get(errorKey),
    showShareBankOnCreate: featureOn('share_bank_on_create')
  };
}
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    createBank: bindActionCreators(createBank, dispatch),
    changeBank: bindActionCreators(changeBank, dispatch),
    clearModifications: bindActionCreators(clearModifications, dispatch),
    showError: bindActionCreators(showError, dispatch),
    hideError: bindActionCreators(hideError, dispatch),
    closeModal: bindActionCreators(modalActions.closeModal, dispatch),
    screenreaderNotification: bindActionCreators(screenreaderNotification, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CreateBankModal);